// extracted by mini-css-extract-plugin
module.exports = {"title":"FeedbackIncident_title__3zSUz","subtitle":"FeedbackIncident_subtitle__1oQJc"};